module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/GUNPOWDER-Layered.8ba8564.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/GUNPOWDER-Layered.jpg
// module id = v4dL
// module chunks = 0